import { onMounted } from 'vue'
import useGet from './api/useGet'

export const useOnboarding = () => {
  const { data, status, load } = useGet<Onboarding>('onboarding')

  onMounted(() => {
    load()
  })

  return {
    data,
    status,
  }
}

export interface Onboarding {
  feedbackTopicId: string
}
